/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { OperationToJSON, UserIncidentFootageFromJSON, UserIncidentFootageToJSON, UserIncidentFootageEntityCursorPageResponseFromJSON, UserIncidentFootageMarkerFromJSON, UserIncidentFootageMarkerToJSON, UserIncidentFootageMarkerCollectionResponseFromJSON, ViewIncidentFileResponseFromJSON, } from '../models/index';
/**
 *
 */
export class AdminIncidentFootageApi extends runtime.BaseAPI {
    /**
     */
    adminIncidentFootageAddMarkerByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentFootageAddMarkerById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{id}/markers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserIncidentFootageMarkerToJSON(requestParameters.userIncidentFootageMarker),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageMarkerFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootageAddMarkerById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootageAddMarkerByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentFootageCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserIncidentFootageToJSON(requestParameters.userIncidentFootage),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootageCreate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootageCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentFootageDeleteByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentFootageDeleteById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    adminIncidentFootageDeleteById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminIncidentFootageDeleteByIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    adminIncidentFootageDeleteMarkerByFootageIdAndMarkerIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.footageId === null || requestParameters.footageId === undefined) {
                throw new runtime.RequiredError('footageId', 'Required parameter requestParameters.footageId was null or undefined when calling adminIncidentFootageDeleteMarkerByFootageIdAndMarkerId.');
            }
            if (requestParameters.markerId === null || requestParameters.markerId === undefined) {
                throw new runtime.RequiredError('markerId', 'Required parameter requestParameters.markerId was null or undefined when calling adminIncidentFootageDeleteMarkerByFootageIdAndMarkerId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{footageId}/markers/{markerId}`.replace(`{${"footageId"}}`, encodeURIComponent(String(requestParameters.footageId))).replace(`{${"markerId"}}`, encodeURIComponent(String(requestParameters.markerId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    adminIncidentFootageDeleteMarkerByFootageIdAndMarkerId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminIncidentFootageDeleteMarkerByFootageIdAndMarkerIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    adminIncidentFootageGetByIdByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentFootageGetByIdById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootageGetByIdById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootageGetByIdByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentFootageGetForDownloadByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentFootageGetForDownloadById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ViewIncidentFileResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootageGetForDownloadById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootageGetForDownloadByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentFootageListMarkersByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentFootageListMarkersById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{id}/markers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageMarkerCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootageListMarkersById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootageListMarkersByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentFootagePaginateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.search !== undefined) {
                queryParameters['search'] = requestParameters.search;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.filters !== undefined) {
                queryParameters['filters'] = requestParameters.filters;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageEntityCursorPageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootagePaginate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootagePaginateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentFootageUpdateByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentFootageUpdateById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-footage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.operation.map(OperationToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentFootageUpdateById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentFootageUpdateByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
